import { LocationDto } from "@braoshzmvavz/picnube-common";
import {
  LoadingOverlay,
  TextInput,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";
import { useEffect, useMemo } from "react";
import { HiSearch } from "react-icons/hi";
import { useAppSelector } from "src/app/hooks";
import LocationList from "./LocationList";
import { useMediaQuery } from "@mantine/hooks";

export default function LocationSelector(props: {
  selectedLocation: LocationDto | null;
  onLocationSelected: (location: LocationDto) => void;
  onLocationSelectedForDetail: (location: LocationDto) => void;
  onSearchValueChange?: (searchValue: string) => void;
  onFocus?: () => void;
  onTextNotEmpty?: () => void;
  cssClassName?: string;
  isMobileAndDropdown?: boolean;
}) {
  const locationState = useAppSelector((state) => state.location);
  const computedColorScheme = useComputedColorScheme("dark");

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const form = useForm({
    mode: "controlled",
    initialValues: {
      search: "",
    },

    validate: (values) => {
      return {
        name:
          values.search.trim().length < 2
            ? "Search must include at least 2 characters"
            : null,
      };
    },
  });

  useEffect(() => {
    if (!props.onSearchValueChange) return;
    props.onSearchValueChange(form.values.search);
  }, [form.values.search]);

  const filteredLocations = useMemo(() => {
    return locationState.locations.filter((location) => {
      const matchesName = location.name
        .toLowerCase()
        .includes(form.values.search.toLowerCase());
      const matchesCountry = location.country
        .toLowerCase()
        .includes(form.values.search.toLowerCase());
      const matchesRegion = location.region
        .toLowerCase()
        .includes(form.values.search.toLowerCase());

      return matchesName || matchesCountry || matchesRegion;
    });
  }, [locationState.locations, form.values.search]);

  useEffect(() => {
    if (form.values.search.length > 0) {
      props.onTextNotEmpty?.();
    }
  }, [form.values.search]);

  return (
    <div className={"flex flex-col h-full overflow-hidden"}>
      <div
        className={
          "flex flex-row justify-between items-center p-4 border-b border-grey-800" +
          (props?.isMobileAndDropdown ? " h-[85px]" : "")
        }
      >
        <TextInput
          className="w-full"
          leftSectionPointerEvents="none"
          leftSection={<HiSearch />}
          placeholder="Location name"
          {...form.getInputProps("search")}
          onFocus={() => props?.onFocus?.()}
        />
      </div>
      {locationState.loading ? (
        <LoadingOverlay
          visible={true}
          zIndex={400}
          overlayProps={{
            blur: "xl",
            color: computedColorScheme === "dark" ? "black" : "black",
            opacity: computedColorScheme === "dark" ? "70%" : "30%",
          }}
          loaderProps={{ color: "blue", type: "oval", size: "md" }}
        ></LoadingOverlay>
      ) : (
        <LocationList
          selectedLocation={props.selectedLocation}
          locations={filteredLocations}
          onLocationSelected={props.onLocationSelected}
          onLocationSelectedForDetail={props.onLocationSelectedForDetail}
        />
      )}
    </div>
  );
}
